import zip from 'lodash/zip';
import head from 'lodash/head';
import sortBy from 'lodash/sortBy';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getFilteredParametersValuesNotEmpty } from 'store/dataset';

import CheckBox from 'components/CheckBox';
import ScatterPlot from 'components/ScatterPlot';


class ScatterPlotContainer extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      showRegressionLine: false
    };

    this.handleRegressionLineCheckboxChange = ({ target }) =>
      this.setState({ showRegressionLine: target.checked });
  }

  get dots () {
    return sortBy(
      zip(
        this.props.firstParsedParameterValues,
        this.props.secondParsedParameterValues
      ),
      head
    );
  }

  render () {
    return (
      <>
        <div className="text-left pl-50">
          <CheckBox
            checked={this.state.showRegressionLine}
            onChange={this.handleRegressionLineCheckboxChange}
          >
            Regression Line
          </CheckBox>
        </div>

        <ScatterPlot
          {...this.state} dots={this.dots}
          xAxisLabel={this.props.firstParameter}
          yAxisLabel={this.props.secondParameter}
        />
      </>
    );
  }
}

ScatterPlotContainer.propTypes = {
  firstParameter: PropTypes.string.isRequired,
  secondParameter: PropTypes.string.isRequired,

  firstParsedParameterValues: PropTypes.arrayOf(PropTypes.number).isRequired,
  secondParsedParameterValues: PropTypes.arrayOf(PropTypes.number).isRequired
};

const mapStateToProps = (state, props) => (getFilteredParametersValuesNotEmpty(
  state,
  props.firstParameter,
  props.secondParameter
));

export default connect(mapStateToProps)(ScatterPlotContainer);
